import { render, staticRenderFns } from "./ResumenParteView.vue?vue&type=template&id=6515c823&scoped=true&"
import script from "./ResumenParteView.vue?vue&type=script&lang=js&"
export * from "./ResumenParteView.vue?vue&type=script&lang=js&"
import style0 from "./ResumenParteView.vue?vue&type=style&index=0&id=6515c823&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6515c823",
  null
  
)

export default component.exports